module.exports = __webpack_public_path__ + "width.svg?2773528f48a59eb7d38d390af8ac94fc";